import { Component, Input, inject } from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { BrandIconComponent } from '@shared/components/brand-icon/brand-icon.component';
import type { BrandIconName } from '@shared/components/brand-icon/brand-icons';
import { ButtonComponent } from '@shared/components/button/button.component';
import { SelectComponent } from '@shared/components/select/select.component';
import { SpinnerComponent } from '@shared/components/spinner/spinner.component';
import { SharedModule } from '@shared/modules/shared.module';
import { platformBrandColor, platformBrandIcon } from 'app/core/constants/platform-brand.constants';
import { ProductCatalogService } from './product-catalog.service';

/** Texts of the picker, already translated by the page (each page has its own copy) */
export interface ProductPickerTexts {
	platform: string;
	loadPlatformsError: string;
	noPlatforms: string;
	service: string;
	loadProductsError: string;
	noProducts: string;
	searchService: string;
	selectService: string;
}

/**
 * Platform pills + service select of the order forms (Boost, Subscriptions). Renders the page's
 * ProductCatalogService; the select binds the page form's `product` control (it must sit inside
 * that form). The host adds no box: both field groups lay out in the form like the page's own fields.
 */
@Component({
	selector: 'app-product-picker',
	imports: [SharedModule, ButtonComponent, SelectComponent, SpinnerComponent, BrandIconComponent],
	templateUrl: './product-picker.component.html',
	styleUrl: './product-picker.component.scss',
	// formControlName resolves against the page's form
	viewProviders: [{ provide: ControlContainer, useFactory: () => inject(ControlContainer, { skipSelf: true }) }],
})
export class ProductPickerComponent {
	@Input({ required: true }) texts!: ProductPickerTexts;

	readonly catalog = inject(ProductCatalogService);

	/** Brand colour of the platform icon (mobile selector) */
	getPlatformColor(platformLabel: string): string {
		return platformBrandColor(platformLabel);
	}

	/** Shared brand icon map (also used by the rest of the panel) */
	getPlatformIcon(platformLabel: string): BrandIconName | null {
		return platformBrandIcon(platformLabel);
	}
}
